import axios from 'axios';

const ROOT = 'api/v1/patient-sources';

const PatientSourceApi = {
  getAllAssignmentPatientSources() {
    return axios.get(`${ROOT}/assignment-options`);
  },
  getAllPatientSources() {
    return axios.get(`${ROOT}`);
  },
  createPatientSource(data) {
    return axios.post(`${ROOT}`, data, { hideLoader: true });
  }
};

export default PatientSourceApi;
